import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ContentProvider } from "@/context/ContentContext";
import { SettingsProvider } from "@/context/SettingsContext";
import ScrollToTop from "@/components/feature/ScrollToTop";
import DynamicFavicon from "@/components/feature/DynamicFavicon";
import ErrorBoundary from "@/components/base/ErrorBoundary";

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <SettingsProvider>
        <DynamicFavicon />
        <ContentProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <ScrollToTop />
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
          </BrowserRouter>
        </ContentProvider>
      </SettingsProvider>
    </I18nextProvider>
  );
}

export default App;